/*eslint-disable no-unused-vars */
/*eslint-disable react-hooks/exhaustive-deps*/
import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Table, Label, Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import SortableHeader from '../../components/SortableHeader';
import { numberFormatter, formatDate } from '../../helpers';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import ConfirmDeleteModal from '../ConfirmDeleteModal';
import NoRecords from '../../components/Table/NoRecords';

const PAGE_SIZE_OPTIONS = [8, 10, 12, 15, 25];

export default function CashExpenseListSideBar({
  cashExpenseList,
  sortBy,
  totalCount,
  currentPage,
  editCashExpense,
  removeCashExpense,
  handlePageClick,
  itemsPerPage = 10,
  onPageSizeChange,
}) {
  const { t } = useTranslation();
  const [localItemsPerPage, setLocalItemsPerPage] = useState(itemsPerPage);
  
  const HeaderList = [
    {
      title: '',  // Edit button column (RIGHT side in RTL)
      value: 'editAction',
      style: { minWidth: '70px', width: '70px' },
      sortable: false,
    },
    {
      title: t('CASHEXPENSE.TABLE_DATE'),
      value: 'createDate',
      style: { minWidth: '150px', width: '10%' },
    },
    {
      title: t('CASHEXPENSE.TABLE_BUSINESS_NAME'),
      value: 'expenseNote',
      style: { width: '20%' },
      sortable: true,
    },
    {
      title: t('CASHEXPENSE.TABLE_EXPENSE_NOTE'),
      value: 'expenseNote',
      style: { minWidth: '150px', width: '40%' },
      sortable: false,
    },
    {
      title: t('CASHEXPENSE.TABLE_PAID_TO'),
      value: 'paidTo',
      style: { minWidth: '150px', width: '20%' },
      sortable: false,
    },
    {
      title: t('CASHEXPENSE.TABLE_EXPENSE_AMOUNT'),
      value: 'expenseAmount',
      style: { minWidth: '150px', width: '20%' },
    },
    {
      title: t('CASHEXPENSE.TABLE_FROM_DATE'),
      value: 'startDate',
      style: { minWidth: '150px', width: '10%' },
      sortable: false,
    },
    {
      title: t('CASHEXPENSE.TABLE_TO_DATE'),
      value: 'endDate',
      style: { width: '10%' },
      sortable: false,
    },
    {
      title: t('CASHEXPENSE.TABLE_INVOICE'),
      value: 'invoice',
      style: { width: '10%' },
      sortable: false,
    },
    {
      title: '',  // Delete button column (LEFT side in RTL)
      value: 'deleteAction',
      style: { minWidth: '70px', width: '70px' },
      sortable: false,
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteCashExpenseDetail, setDeleteCashExpenseDetail] = useState({});

  const handleDeleteAction = (data) => {
    setShowDeleteModal(true);
    setDeleteCashExpenseDetail({
      ...data,
      ud: false,
    });
  };

  const handleConfirmDeleteAction = () => {
    removeCashExpense(deleteCashExpenseDetail);
    setShowDeleteModal(false);
  };

  const handleCancelAction = () => {
    setDeleteCashExpenseDetail({});
    setShowDeleteModal(false);
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    setLocalItemsPerPage(newSize);
    if (onPageSizeChange) {
      onPageSizeChange(newSize);
    }
  };

  return (
    <React.Fragment>
      <Table striped bordered responsive size="sm">
        <thead>
          <tr>
            <SortableHeader 
              headers={HeaderList} 
              isDisabled={cashExpenseList.length === 0} 
              sortClick={sortBy}
              showActionCol={false}
            />
          </tr>
        </thead>
        <tbody>
          {cashExpenseList.map((item, l0Idx) => (
            <tr key={l0Idx}>
              {/* Edit button - RIGHT side in RTL */}
              <td className="text-center">
                <Button 
                  color="primary" 
                  size="sm" 
                  title={t('CASHEXPENSE.LIST_ACTION_EDIT')} 
                  onClick={() => editCashExpense(item)}
                >
                  {t('CASHEXPENSE.EDIT_BTN') || t('EDIT') || 'שנה'}
                </Button>
              </td>
              <td>{formatDate(item.createdDate, 'dd/mm/yyyy')}</td>
              <td>{item.locationName}</td>
              <td>{item.expenseNote}</td>
              <td>{item.paidTo}</td>
              <td>{numberFormatter(item.expenseAmount)}</td>
              <td>{formatDate(item.startDate, 'dd/mm/yyyy')}</td>
              <td>{formatDate(item.endDate, 'dd/mm/yyyy')}</td>
              <td align="center">
                {item.invoice ? (
                  <i className="ri-check-fill text-success"></i>
                ) : (
                  <i className="ri-close-fill text-danger"></i>
                )}
              </td>
              {/* Delete button - LEFT side in RTL */}
              <td className="text-center">
                <Button 
                  color="danger" 
                  size="sm" 
                  title={t('CASHEXPENSE.LIST_ACTION_REMOVE')} 
                  onClick={() => handleDeleteAction(item)}
                >
                  {t('CASHEXPENSE.DELETE_BTN') || 'לבטל'}
                </Button>
              </td>
            </tr>
          ))}

          {!isLoading && cashExpenseList.length === 0 && <NoRecords colSpan={HeaderList.length} />}
        </tbody>
      </Table>

      {/* Pagination and Rows per page */}
      <div className="custom-pagination mt-2 d-flex justify-content-between align-items-center flex-row-reverse">
        {/* Rows per page - RIGHT side in RTL */}
        <div className="d-flex align-items-center gap-2">
          <Label className="mb-0">{t('ROWS_PER_PAGE') || 'שורות לדף'}:</Label>
          <Input
            type="select"
            value={localItemsPerPage}
            onChange={handlePageSizeChange}
            style={{ width: '80px' }}
            bsSize="sm"
          >
            {PAGE_SIZE_OPTIONS.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </Input>
        </div>

        {/* Pagination - LEFT side in RTL */}
        <PaginationControl
          page={currentPage}
          total={totalCount}
          limit={localItemsPerPage}
          changePage={handlePageClick}
          next={true}
          last={true}
          ellipsis={1}
        />
      </div>

      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        isLoading={isLoading}
        confirmFn={handleConfirmDeleteAction}
        cancelFn={handleCancelAction}
      />
    </React.Fragment>
  );
}
